/**
 * Must be called with `this` bound to TextBlock.
 */
export default function findSpellingsStrategy(contentBlock, callback) {
  const { block } = this.props;

  if (!block.get('spellings').size && !this.props.globalSpellings.size) {
    return;
  }

  const spellings = block.get('spellings').size
    ? block.get('spellings')
    : this.props.globalSpellings;
  const text = contentBlock.getText();

  spellings.forEach((spelling) => {
    const regex = new RegExp(`(^|\\s+)(${spelling.get('word')})(?=\\s|$)`, 'gi');
    let result;

    while (result = regex.exec(text)) { // eslint-disable-line no-cond-assign
      const start = result.index + result[1].length;
      const end = start + spelling.get('wordLength');
      const props = {
        blockKey: this.props.block.get('key'),
        draftBlockKey: contentBlock.getKey(),
        suggestions: spelling.get('suggestions'),
        word: spelling.get('word'),
        start,
        end,
        handleContentStateChange: this.handleContentStateChange,
      };

      if (start === spelling.get('column')) callback(start, end, props);
    }
  });
}
